import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const {
  endpoints: {
    account: { externalLogin: url },
  },
} = config

/**
 * Obtain auth token given an email & password.
 *
 * @param {String} data.email User email
 * @param {String} data.password User password
 */
export default (data) => axios.post(url, data, { headers: getHeaders() })
